import { create } from "zustand";
import type {
  CurrencyCode,
  InvoiceStatus,
} from "@/domain/types";

interface AppStore {
  dashboardSearch: string;
  dashboardStatus:
    | InvoiceStatus
    | "overdue"
    | "all";
  dashboardCurrency: CurrencyCode | "all";
  setDashboardSearch: (value: string) => void;
  setDashboardStatus: (
    value: InvoiceStatus | "overdue" | "all",
  ) => void;
  setDashboardCurrency: (
    value: CurrencyCode | "all",
  ) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  dashboardSearch: "",
  dashboardStatus: "all",
  dashboardCurrency: "all",
  setDashboardSearch: (dashboardSearch) =>
    set({ dashboardSearch }),
  setDashboardStatus: (dashboardStatus) =>
    set({ dashboardStatus }),
  setDashboardCurrency: (dashboardCurrency) =>
    set({ dashboardCurrency }),
}));
